import { Alert, AlertPage, AlertTitle } from 'components'
import './styles.scss'
import { useEffect, useState } from 'react'
import { AdminUser } from 'core';
import moment from 'moment-timezone';

export const WithdrawlLogsInfoAlert = ({ id, onClose }) => {
    const [withdrawlLogs, setWithdrawlLogs] = useState([]);
    const getWitdrawlLogs = async () => {
        const logs = await AdminUser.getLockrPayWithdrawlsLogs(id)
        setWithdrawlLogs(logs)
    }
    useEffect(() => {
        getWitdrawlLogs()
    }, [])

    return <Alert onCancel={() => onClose()}>
        <AlertPage>
            <AlertTitle>
                Withdrawl Logs
            </AlertTitle>
            <div className={`user-list-item ${true && 'header'}`} onClick={() => handleClick()}>

                <>
                    <div style={{ minWidth: 300 }} className="email">Event</div>
                    <div className="email">status</div>
                    <div className="email">Created</div>
                </>


            </div>
            {withdrawlLogs.map((w) => (

                <div className={`user-list-item`} >
                    <div style={{ minWidth: 300 }} className="email">{w.eventtype}</div>
                    <div className="email">{w.status}</div>
                    <div className="email">{moment(w.createdAt).format('MM/DD/YYYY')}</div>


                </div>
            ))
            }
        </AlertPage>
    </Alert >
}